"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPieChartOptions = void 0;
var defaultPieChartOptions = {
  chart: {
    type: 'pie',
    margin: 0,
    styledMode: true
  },
  title: false,
  subtitle: {
    useHTML: true
  },
  plotOptions: {
    pie: {
      center: ['50%', '50%']
    }
  },
  tooltip: {
    enabled: false
  },
  series: [{
    dataLabels: false,
    innerSize: '83%',
    states: {
      hover: {
        enabled: false
      }
    }
  }],
  credits: false
};
exports.defaultPieChartOptions = defaultPieChartOptions;